import type {FrontendRuntime} from "@shifath/platform-admin-core";
import {DashboardPage} from "./internal/presentation/dashboard_page";
import {PreviewDashboardConnection} from "./internal/connection/preview_dashboard_connection";
import {BackendDashboardConnection} from "./internal/connection/backend_dashboard_connection";
export function buildFeatureRoute(path:string, runtime:FrontendRuntime) {
  if (path !== "/") throw new Error(`dashboard does not own ${path}`);
  if (runtime.dataSource === "preview") return <DashboardPage connection={new PreviewDashboardConnection()}/>;
  if (!runtime.api) throw new Error("Backend runtime missing ApiExecutor");
  return <DashboardPage connection={new BackendDashboardConnection(runtime.api)}/>;
}
